(function () {
    //'use strict';

    angular
        .module('app')
        .controller('flashEditHTS', flashEditHTS);

    function flashEditHTS($scope, $rootScope, $timeout, $state, SharedData, PatternService, SeasonService, toaster,
        GridUtil, HtsFlashEditService, FileService, ImportService, SearchFactory, ExportService, cfpLoadingBar) {

        var model = this;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }



        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 17) {
                if (userPermissionRow[1] == 2) {
                    model.HTSEdit = true;
                }
            }
        });

        if (!model.HTSEdit) {
            $state.go('permissionDenied');
        }

        $scope.brands = [];
        $scope.seasons = [];
        $scope.genders = [];
        $scope.factories = [];
        model.showSearchHelpForMultipleValues = true;

        var globalPageNumber = 1;
        var globalPageSize = 50;

        $scope.currentRow = {};
        $scope.selectedRegion = '';
        $scope.DestinationCountry = '';

        $scope.windowGridHeight = function () {
            if (window.outerHeight >= 768) {
                return window.innerHeight - 315;
            } else {
                var size = $scope.totalRecords < $scope.pageSize ? $scope.totalRecords : $scope.pageSize;
                return (size * gridOptions.rowHeight) + 46;
            }
        };

        $scope.pagingOptions = [15, 25, 50, 100];

        $scope.onBtnBeg = function () {
            $scope.pageNumber = 1;
            $scope.onPageChanged(1);
        };

        $scope.onBtnEnd = function () {
            $scope.pageNumber = $scope.totalPages;
            $scope.onPageChanged($scope.totalPages);
        };

        $scope.onBtnPrev = function (e) {
            if (e > 1) {
                e = e - 1;
                $scope.pageNumber = e;
                $scope.onPageChanged(e);
            }
        };

        $scope.onBtnNext = function (e) {
            if (e < $scope.totalPages) {
                e = e + 1;
                $scope.pageNumber = e;
                $scope.onPageChanged(e);
            }
        };

        $scope.onPageChanged = function (e) {
            globalPageNumber = e;
            $scope.getHTS();
        };

        $scope.onPageSizeChanged = function (e) {
            globalPageSize = e;
            globalPageNumber = 1;
            $scope.getHTS();
        };

        var globalRowHeight = 30;

        $scope.stawnGroups = {
            "US": ['UsHtsStawn', 'UsAssignDuty', 'US', 'UsHtsCodeKey'],
            "CA": ['CaHtsStawn', 'CaAssignDuty', 'CA', 'CaHtsCodeKey'],
            "UK": ['UkHtsStawn', 'UkAssignDuty', 'GB', 'UkHtsCodeKey'],
            "EU": ['EuHtsStawn', 'EuAssignDuty', 'NL', 'EuHtsCodeKey']
        };

        //array to host invalid entries
        $scope.invalidEntries = [];

        $scope.validateCell = function (row) {
            //strip the first two characters from the column name to get the country code
            //e.g., "UsHtsStawn" becomes "US"
            $scope.selectedRegion = row.colDef.field.substring(0, 2).toUpperCase();

            //now tranlsate to destination country we need for search help
            $scope.DestinationCountry = $scope.stawnGroups[$scope.selectedRegion][2];
            $scope.OriginCountry = row.data.CtryOfOrig;

            //get reference to current row
            $scope.currentRow = row;

            //HTS code has been deleted by the user
            var newValue = row.newValue; //trim it to win it
            if (newValue === "" || newValue === null) {
                $scope.setGridValues($scope.stawnGroups[$scope.selectedRegion][0], newValue, $scope.stawnGroups[$scope.selectedRegion][1], "", $scope.stawnGroups[$scope.selectedRegion][3], null);
                $scope.saveEdits(row.data);
                return;
            }

            if (model.showSearchHelpForMultipleValues === false) {
                model.showSearchHelpForMultipleValues = true;
                $scope.saveEdits(row.data);
                return;
            }

            var modalSearch = SearchFactory.htsDutySearch($scope.OriginCountry, $scope.DestinationCountry, function (htsDuty) {

                if (!htsDuty) {
                    model.showSearchHelpForMultipleValues = false;

                    $scope.invalidEntries.push(row.colDef.field + row.node.rowIndex);

                    $scope.setGridValues(
                        row.colDef.field,
                        null,
                        $scope.stawnGroups[$scope.selectedRegion][1],
                        "",
                        $scope.stawnGroups[$scope.selectedRegion][3],
                        "",
                        [row.node.rowIndex, row.colDef.field]);

                } else {

                    var idx = $scope.invalidEntries.indexOf(row.colDef.field + row.node.rowIndex);

                    if (idx > -1) {
                        $scope.invalidEntries.splice(idx, 1);
                    }

                    $scope.setGridValues(
                        row.colDef.field,
                        row.newValue,
                        $scope.stawnGroups[$scope.selectedRegion][1],
                        htsDuty.Duty,
                        $scope.stawnGroups[$scope.selectedRegion][3],
                        htsDuty.HTSKey);

                    $scope.saveEdits(row.data);
                }
            });

            modalSearch.startSearch(true, [newValue]);
        };

        $scope.saveEdits = function (row) {
            //var rowEntity = row.entity;

            //create a data object and assign its values to the values in the Grid row
            var updateData = {
                PrototypeSeasonalId: row.PrototypeSeasonalId,
                UsHtsStawn: row.UsHtsStawn,
                UsAssignDuty: row.UsAssignDuty,
                UsHtsCodeKey: row.UsHtsCodeKey,
                CaHtsStawn: row.CaHtsStawn,
                CaAssignDuty: row.CaAssignDuty,
                CaHtsCodeKey: row.CaHtsCodeKey,
                UkHtsStawn: row.UkHtsStawn,
                UkAssignDuty: row.UkAssignDuty,
                UkHtsCodeKey: row.UkHtsCodeKey,
                EuHtsStawn: row.EuHtsStawn,
                EuAssignDuty: row.EuAssignDuty,
                EuHtsCodeKey: row.EuHtsCodeKey
            };

            //send the data object to the API
            HtsFlashEditService
                .updateDetails(updateData)
                .catch(function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error performing the update: ' + error + ', ' + status,
                        timeout: 5000
                    });
                });
        };

        $scope.gridSearchHelpData = function (params) {

            if (params) {

                if (params.data.CtryOfOrig == null) {

                    var template = '<span class="full-width" style="float:left;"><span id="searchHelp" class="btn-circle uneditable">'
                        + '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></span>';

                    var tempDiv = document.createElement('div');

                    tempDiv.innerHTML = template;

                    this.eGui = tempDiv.firstElementChild;

                    return this.eGui;

                } else {

                    //check if this field is invalid or not and insert a span to show validation
                    var idx = $scope.invalidEntries.indexOf(params.colDef.field + params.node.rowIndex);

                    if (idx > -1) {
                        var validation = "<span class='ag-grid-invalid'></span>";
                    } else {
                        var validation = '';
                    }

                    var template = '<span><span id="searchHelpValue"></span><a id="searchHelp" class="btn-circle"><i class="fa fa-search"></i></a>' + validation + '</span>';
                    var tempDiv = document.createElement('div');

                    tempDiv.innerHTML = template;
                    this.eGui = tempDiv.firstElementChild;

                    // attach the value to the value span
                    var eValue = this.eGui.querySelector('#searchHelpValue');
                    eValue.innerHTML = params.value;

                    $scope.$evalAsync();

                    // setup the button, first get reference to it
                    this.eButton = this.eGui.querySelector('#searchHelp');
                    this.eButton.addEventListener('click', function () {
                        $scope.searchHelp(params, "");
                    });
                    return this.eGui;
                }
            }
        };

        //define custom editor class
        function customCellEditor() {
        }

        var inputClass = 'ag-cell-edit-input';

        customCellEditor.prototype.init = function (params) {
            this.params = params;
            this.eInput = document.createElement('div');
            this.eInput.className = inputClass;
            this.eInput.type = 'text';
            this.eInput.innerHTML = '<input class="' +
                inputClass +
                '" type="text" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"/><a id="searchHelp" class="btn-circle"><i class="fa fa-search"></i></a>';

            //assignment back from API changes or a direct input change
            if (params.charPress) {
                this.eInput.getElementsByClassName(inputClass)[0].value = params.charPress;
            } else {
                this.eInput.getElementsByClassName(inputClass)[0].value = params.value;
            }

            this.eButton = this.eInput.querySelector('#searchHelp');
            this.eButton.addEventListener('click',
                function () {
                    $scope.searchHelp(params, "");
                });
        };

        customCellEditor.prototype.getGui = function () {
            return this.eInput;
        };

        // focus and select can be done after the gui is attached
        customCellEditor.prototype.afterGuiAttached = function () {
            var l = this.params.value ? this.params.value.toString().length : '';

            this.eInput.getElementsByClassName(inputClass)[0].value = this.eInput.getElementsByClassName(inputClass)[0].value;

            if (!this.params.charPress) {
                this.eInput.getElementsByClassName(inputClass)[0].setSelectionRange(0, l);
            } else {
                if (l !== "") {
                    this.eInput.getElementsByClassName(inputClass)[0].setSelectionRange(l, l);
                }
            }

            this.eInput.getElementsByClassName(inputClass)[0].focus();
        };

        // returns the new value after editing
        customCellEditor.prototype.isCancelBeforeStart = function () {

            if (this.params.node.data.CtryOfOrig == null) {
                if (!$scope.toasterTimeout) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'Unable to edit, Factory is missing.',
                        timeout: 5000
                    });
                    $scope.$evalAsync();
                    $scope.toasterTimeout = $timeout(function () {
                        $scope.toasterTimeout = false;
                    }, 5000);
                    gridOptions.api.setFocusedCell(this.params.rowIndex, this.params.column.colId);
                }
                return true;
            } else {
                return this.cancelBeforeStart;
            }
        };

        // returns the new value after editing
        customCellEditor.prototype.getValue = function () {
            return this.eInput.getElementsByClassName(inputClass)[0].value;
        };

        //build gridoptions, build columns
        var gridOptions = {
            rowHeight: globalRowHeight,
            enableColResize: true,
            enableFilter: false,
            enableSorting: false,
            enableServerSideSorting: true,
            paginationPageSize: globalPageSize,
            suppressContextMenu: true,
            suppressMultiSort: true,
            suppressSorting: false,
            suppressDragLeaveHidesColumns: true,
            suppressMovableColumns: true, //set to false to stop from moving colums
            suppressRowHoverClass: true,
            suppressColumnMoveAnimation: true,
            suppressColumnVirtualisation: true,
            showToolPanel: false,
            stopEditingWhenGridLosesFocus: true,
            getRowNodeId: function (data) { return data.PrototypeSeasonalId; },
            onCellValueChanged: function (params) {
                //convert any nulls to ''
                var oldValue = params.oldValue == null ? '' : params.oldValue;
                var newValue = params.newValue == null ? '' : params.newValue;

                if (oldValue !== newValue && params.colDef.field.toLowerCase().indexOf('stawn') > -1 && !$scope.noValidateNecessary) {
                    $scope.validateCell(params);
                }
            },
            onCellClicked: function (params) {
                if (params.colDef.field !== 'Url' && params.colDef.colorwayLink) {
                    $state.go('colorway', { 'prototypeSeasonalId': params.data.PrototypeSeasonalId });
                }
            },

            onSortChanged: function (e) {
                var sortObj = gridOptions.api.getSortModel();

                $scope.searchForm.sortColumn = sortObj.length ? sortObj[0].colId : "";
                $scope.searchForm.sortDirection = sortObj.length ? sortObj[0].sort : "";

                $scope.getHTS();
            }
        };

        $scope.onBtExport = function () {
            gridOptions.api.showLoadingOverlay();
            $scope.getHTS(true);
        };

        $scope.getCellRenderers = function () {
            return {
                'check': GridUtil.check,
                'dateParse': GridUtil.dateParse,
                'percent': GridUtil.percent,
                'currency': GridUtil.currency,
                'gridSearchHelpData': $scope.gridSearchHelpData,
                'specUrl': function (params) {
                    if (params && params.value) {
                        return '<a target="_blank" href="' + params.value + '">Spec</a>';
                    }
                    return '';
                }
            };
        };

        function setScopeLevelSearchInfo(response) {

            $scope.totalRecords = response.totalRecords;
            $scope.pageSize = response.pageSize;
            $scope.pageNumber = response.currentPage;
            $scope.totalPages = response.totalPages;

            $scope.lastRecord = $scope.pageNumber == $scope.totalPages
                ? $scope.totalRecords
                : $scope.pageNumber * $scope.pageSize;

            $scope.firstRecord = $scope.pageNumber == $scope.totalPages
                ? (($scope.pageNumber - 1) * $scope.pageSize) + 1
                : $scope.lastRecord - $scope.pageSize + 1;

            $scope.columnDefs = $scope.getColumnDefs(response);
        }

        function setGridSorting(columnDefs) {

            var colId = $scope.searchForm.sortColumn;
            var sort = $scope.searchForm.sortDirection;

            GridUtil.setSort(columnDefs, colId, sort);
        }

        function renderGrid(gridDiv, columnDefs, searchResults) {
            gridOptions.columnDefs = columnDefs;

            if (gridDiv.children.length == 0) {
                new agGrid.Grid(gridDiv, gridOptions);
            } else {
                gridOptions.api.setColumnDefs(gridOptions.columnDefs);
            }

            gridOptions.api.setRowData(searchResults);
            gridOptions.api.hideOverlay();
        }

        $scope.getColumnDefs = function (response) {

            var colDefs = response.columnGroups[0].columns;

            var cellRenderers = $scope.getCellRenderers();

            var customEditors = {
                'customCellEditor': customCellEditor
            };

            angular.forEach(colDefs, function (col) {

                if (col.cellRenderer) {
                    col.cellRenderer = cellRenderers[col.cellRenderer];
                }

                if (col.cellEditor) {
                    col.cellEditor = customEditors[col.cellEditor];
                }
            });

            return colDefs;
        };

        $scope.getHTS = function (exportToExcel) {
            $scope.flashEditHTS.$setSubmitted();

            if ($scope.flashEditHTS.$invalid) {
                return;
            }

            var searchObject = {
                brandId: $scope.searchForm.brandId ? $scope.searchForm.brandId : null,
                seasonId: $scope.searchForm.seasonId ? $scope.searchForm.seasonId : null,
                projectName: $scope.searchForm.projectName ? $scope.searchForm.projectName : null,
                prototypeSeasonalId: $scope.searchForm.prototypeSeasonalId ? $scope.searchForm.prototypeSeasonalId : null,
                patternName: $scope.searchForm.patternName ? $scope.searchForm.patternName : null,
                statusId: $scope.searchForm.statusId ? $scope.searchForm.statusId : null,
                genderKey: $scope.searchForm.genderKey ? $scope.searchForm.genderKey : null,
                factoryKey: $scope.searchForm.factoryKey ? $scope.searchForm.factoryKey : null,
                factoryName: $scope.searchForm.factoryName ? $scope.searchForm.factoryName : null,
                stockNum: $scope.searchForm.stockNum ? $scope.searchForm.stockNum : null,
                pageNumber: globalPageNumber,
                pageSize: globalPageSize,
                sortColumn: $scope.searchForm.sortColumn,
                sortDirection: $scope.searchForm.sortDirection
            };

            if (exportToExcel) {
                searchObject.pageNumber = 1;
                searchObject.pageSize = 0;
            }

            HtsFlashEditService
                .search(searchObject)
                .then(function (response) {
                    if (!response || response.results.length <= 0) {
                        toaster.pop({ type: 'error', title: 'Error!', body: 'No colorways found.', timeout: 5000 });
                        return;
                    }

                    if (exportToExcel) {
                        ExportService.excelExport({
                            reportName: 'HTS Flash Edit',
                            explicitExportColumns: true,
                            searchResults: response.results,
                            columnDefs: gridOptions.columnDefs,
                            exportColumnFilter: $scope.exportColumnFilter
                        });
                        return;
                    }

                    var gridDiv = document.querySelector('#myGrid');

                    setScopeLevelSearchInfo(response);

                    setGridSorting($scope.columnDefs);

                    renderGrid(gridDiv, $scope.columnDefs, response.results);

                    if (!$scope.region)
                        $scope.region = "US";
                    $scope.setRegionVisibility($scope.region);

                    $scope.showGrid = true;
                    $scope.showSearchForm = false;

                    $scope.flashEditHTS.$setPristine();
                },
                    function (error, status) {
                        toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error retrieving Prototypes. Please contact the system administrator', timeout: 5000 });
                    })
                .finally(function () {
                    gridOptions.api.hideOverlay();
                });
        };

        $scope.searchHelp = function (params, searchInput) {
            $scope.currentRow = params;

            //strip the first two characters from the column name to get the country code
            //e.g., "UsHtsStawn" becomes "US"

            //do extra stuff because ag grid has different structures for objects
            if (typeof params.colDef !== "undefined") {
                $scope.selectedRegion = params.colDef.field.substring(0, 2).toUpperCase();
                $scope.DestinationCountry = $scope.stawnGroups[$scope.selectedRegion][2];
            } else {
                $scope.selectedRegion = params.column.colDef.field.substring(0, 2).toUpperCase();
                $scope.DestinationCountry = $scope.stawnGroups[$scope.DestinationCountry][2];
            }

            //do more extra stuff because ag grid has different structures for objects
            if (typeof params.data !== "undefined") {
                $scope.OriginCountry = params.data.CtryOfOrig;
            } else {
                $scope.OriginCountry = params.node.data.CtryOfOrig;
            }

            if ($scope.OriginCountry === "" || $scope.OriginCountry === null) {
                //default country code to China
                //no country of origin found, this is required for searching, throw an error
                toaster.pop({ type: 'error', title: 'Error!', body: 'No valid country of origin found.', timeout: 5000 });
                return;
            }

            var modalSearch = SearchFactory.htsDutySearch($scope.OriginCountry, $scope.DestinationCountry, function (htsDuty) {
                model.showSearchHelpForMultipleValues = false;

                gridOptions.api.stopEditing();

                var selectedStawnGroupRegion = $scope.stawnGroups[$scope.selectedRegion];
                
                $scope.setGridValues(
                    selectedStawnGroupRegion[0],
                    htsDuty.HTSStawn,
                    selectedStawnGroupRegion[1],
                    htsDuty.Duty,
                    selectedStawnGroupRegion[3],
                    htsDuty.HTSKey
                    );

                //set a focus back on the cell so you can use keyboard functions to navigate around
                var col = typeof $scope.currentRow.colDef !== 'undefined'
                    ? $scope.currentRow.colDef.field
                    : $scope.currentRow.column.colId;

                gridOptions.api.setFocusedCell($scope.currentRow.node.childIndex, col);

                var idx = $scope.invalidEntries.indexOf($scope.currentRow.colDef.field + $scope.currentRow.node.rowIndex);

                if (idx > -1) {
                    $scope.invalidEntries.splice(idx, 1);
                }
            });

            modalSearch.startSearch(false, [searchInput]);
        };

        $scope.setGridValues = function (colKey1, colVal1, colKey2, colVal2, colKey3, colVal3, error) {
            if (!$scope.currentRow.data)
                return;

            var rowNode = gridOptions.api.getRowNode($scope.currentRow.data.PrototypeSeasonalId);

            if (colKey1) {
                rowNode.setDataValue(colKey1, colVal1);
            }

            if (colKey2) {

                rowNode.setDataValue(colKey2, colVal2);
            }

            if (colKey3) {
                rowNode.setDataValue(colKey3, colVal3);
            }

            //set focus on the field with the error
            if (error) {
                gridOptions.api.setFocusedCell($scope.currentRow.rowIndex || $scope.currentRow.node.childIndex, colKey1);
            }
        };

        //getPage();

        var HTSCols = [
            'UsHtsStawn', 'CaHtsStawn', 'UkHtsStawn', 'EuHtsStawn', 'UsAssignDuty', 'CaAssignDuty', 'UkAssignDuty',
            'EuAssignDuty', 'UsHtsCodeKey', 'CaHtsCodeKey', 'UkHtsCodeKey', 'EuHtsCodeKey'
        ];

        $scope.columnsSet = function (arr, tf) {
            for (var i = 0; i < arr.length; i++) {
                gridOptions.columnApi.setColumnVisible(arr[i], tf);
            }
        };

        $scope.setRegionVisibility = function (region) {

            $scope.region = region;

            var usCols = ['UsHtsStawn', 'UsAssignDuty', 'UsHtsCodeKey'],
                caCols = ['CaHtsStawn', 'CaAssignDuty', 'CaHtsCodeKey'],
                ukCols = ['UkHtsStawn', 'UkAssignDuty', 'UkHtsCodeKey'],
                euCols = ['EuHtsStawn', 'EuAssignDuty', 'EuHtsCodeKey'],
                exportFilter = function (g1, g2, g3, col) {
                    return _.chain().union(g1, g2, g3).contains(col.field).value() === false;
                };

            switch (region) {
                case 'US':
                    $scope.columnsSet(HTSCols, false);
                    $scope.columnsSet(usCols, true);
                    $scope.exportColumnFilter = function (col) {
                        return exportFilter(caCols, ukCols, euCols, col);
                    };
                    break;
                case 'CAN':
                    $scope.columnsSet(HTSCols, false);
                    $scope.columnsSet(caCols, true);
                    $scope.exportColumnFilter = function (col) {
                        return exportFilter(usCols, ukCols, euCols, col);
                    };
                    break;
                case 'UK':
                    $scope.columnsSet(HTSCols, false);
                    $scope.columnsSet(ukCols, true);
                    $scope.exportColumnFilter = function (col) {
                        return exportFilter(usCols, caCols, euCols, col);
                    };
                    break;
                case 'EU':
                    $scope.columnsSet(HTSCols, false);
                    $scope.columnsSet(euCols, true);
                    $scope.exportColumnFilter = function (col) {
                        return exportFilter(usCols, caCols, ukCols, col);
                    };
                    break;
                default:
                    $scope.columnsSet(HTSCols, true);
                    $scope.exportColumnFilter = null;
            }
        };

        function getPage() {

            SharedData.getUserDefaults()
                .then(function (response) {
                    if (response) {
                        $scope.searchForm = {};
                        $scope.brands = response.brands;
                        $scope.seasons = response.seasons;
                        $scope.searchForm.brandId = response.brandId;
                        $scope.searchForm.seasonId = response.seasonId;
                    } else {
                        console.log('Error getting shared data');
                    }

                    cfpLoadingBar.complete();
                });

            $scope.showSearchForm = true;
            $scope.showGrid = false;
            getGenders();
        };

        $scope.getSeason = function (brandId) {
            if (brandId) {
                SeasonService.getSeasonsByBrand(brandId).then(function (response) {
                    if (response) {
                        $scope.seasons = response;
                        $scope.noBrandSelected = false;
                    }
                });

            } else {
                $scope.seasons.length = 0;
                var season = { SeasonId: 0, Description: '-- Select Season --' };
                $scope.seasons.push(season);
                $scope.noBrandSelected = true;
            }
        };

        function getGenders() {
            //populate gender
            PatternService.getGenders("", 0).then(function (response) {
                if (response) {
                    $scope.genders = response;
                }
                cfpLoadingBar.complete();
            });
        }

        $scope.toggleSearchAndResults = function () {
            if ($scope.showGrid) {
                $scope.showGrid = false;
                $scope.showSearchForm = true;
            } else {
                $scope.showGrid = true;
                $scope.showSearchForm = false;
            }
        };

        function clearFileSelect() {
            $scope.selectImportFile = {};
            document.getElementById('file').value = null;
        }

        $scope.importFile = function (e) {

            var file = e.files[0],
                toastTitle = 'HTS Import';

            FileService
                .readFile(file)
                .then(function (uploadFile) {
                    ImportService
                        .htsFlashEdit(uploadFile)
                        .then(function (result) {
                            toaster.pop({
                                type: 'success',
                                title: toastTitle,
                                body: result,
                                timeout: 5000
                            });
                            clearFileSelect();
                        },
                            function (result) {
                                toaster.pop({
                                    type: 'error',
                                    title: toastTitle,
                                    body: result,
                                    timeout: 3000
                                });
                                clearFileSelect();
                            });

                }, function (result) {
                    clearFileSelect();
                });

            $scope.showSearchForm = true;
            $scope.showGrid = false;
        };
    }
})();
